import { useEffect, useRef } from 'react';

import { css } from '@emotion/css';
import { ScreenBreakpoint } from 'src/styles';

import { drawDonutChart } from './drawDonutChart';

const modalButtonStyle = css`
  min-width: 280px;
  min-height: 280px;

  @media (max-width: ${ScreenBreakpoint.mobile.min}) {
    min-width: 100%;
  }
`;

interface DonutChartProps {
  data: number[];
  colors: string[];
  total: number;
  isLoading: boolean;
  hasError: boolean;
  error?: string;
}

export const DonutChart = ({ data, colors, total, isLoading, hasError, error }: DonutChartProps) => {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current)
      drawDonutChart({
        element: ref.current,
        data,
        colors,
        total,
        isLoading,
        hasError,
        error,
      });
  }, [ref, data, colors, total, isLoading, hasError, error]);

  return (
    <div className={modalButtonStyle}>
      <div className='graph' ref={ref} />
    </div>
  );
};
